import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { reduxForm } from "redux-form";
import { IStore } from "../../DataTypes/storeTypes";
import { setIdempotencyKey, stripePay } from "../../Actions/stripeActions";
import { CreditCardFormConnected } from "./CreditCardForm";
import { IStripeFormData } from "../../../../Common/Stripe/types";
import { Stripe, StripeElements } from "@stripe/stripe-js";
import { Button } from "@powerdiary/components-library/lib";

interface IProps {
    isBusy: boolean;
    isEdit: boolean;

    stripe: Stripe;
    elements: StripeElements;

    handleSubmit();
    onSubmit(values);
}

class PaymentForm extends Component<IProps> {
    render() {
        return (
            <>
                <div className="row h-100">
                    <div className="col-12 h-100">
                        <div className="payment-details-box h-100">
                            <form onSubmit={this.props.handleSubmit}>
                                <CreditCardFormConnected />

                                <Button
                                    variant="contained"
                                    type="submit"
                                    size="large"
                                    className="btn-block"
                                    disabled={this.props.isBusy || !this.props.isEdit}
                                >
                                    Add Card
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const PaymentReduxForm = reduxForm({
    form: "stripeForm",
    getFormState: (state: IStore) => state.stripeForm,
    initialValues: {
        storecard: false,
    },
})(PaymentForm);

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        isBusy: state.common.isBusy,
        isEdit: !state.stripe.cardInfo || state.stripe.isCreditCardEdit,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        onSubmit: (values: IStripeFormData) => {
            dispatch(setIdempotencyKey());
            dispatch(stripePay(values, ownProps.stripe, ownProps.elements));
        },
    };
};

export const PaymentFormInjected: ConnectedComponent<typeof PaymentReduxForm, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentReduxForm);
